var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9146ff;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitch"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Twitch-2",
    "data-name": "Twitch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twitch-3",
    "data-name": "Twitch",
    className: "cls-2",
    d: "M1188,333.75l-21,21v75.75h25.25v21l21-21h16.83L1268,392.67V333.75Zm71.54,54.71-16.83,16.83h-16.83L1211.19,420V405.29h-18.94V342.17h67.33Z",
    transform: "translate(-1108 -277)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Twitch-4",
    "data-name": "Twitch",
    className: "cls-2",
    x: 130.54,
    y: 79.9,
    width: 8.42,
    height: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Twitch-5",
    "data-name": "Twitch",
    className: "cls-2",
    x: 107.4,
    y: 79.9,
    width: 8.42,
    height: 25.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.21b8e6d493c40d6980c51fbdec28c8ff.svg";
export { ForwardRef as ReactComponent };